module.exports = __webpack_public_path__ + "static/android-c889cc7f39d6fed6c3ac55bd4c992580.png";